import { css } from 'lit';
export const buttons = css `
  .small-button {
    height: 30px !important;
    padding: 6px 16px !important;
  }

  .large-button {
    height: 56px !important;
  }

  .primary-button {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    height: 40px;
    min-width: 80px;
    padding: 10px 16px;
    outline: none;
    cursor: pointer;
    color: var(--type-color-inverted);
    background-color: var(--interactive-color-primary-default);
    border-color: transparent;
    border-width: 0;
    border-radius: 4px;
    transition: background-color 150ms ease-out, color 150ms ease-out, fill 150ms ease-out, border-color 150ms ease-out;
    font-size: 16px;
    line-height: 20px;
    font-weight: bold;
    text-decoration: none;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .primary-button:hover {
    background-color: var(--interactive-color-primary-hover);
  }

  .primary-button:active {
    background-color: var(--interactive-color-primary-pressed);
  }

  .primary-button:disabled {
    cursor: auto;
    color: var(--type-color-disabled);
    background-color: var(--interactive-color-disabled);
  }

  .primary-button:disabled .button-icon {
    --goto-icon-color: var(--icon-color-disabled);
    fill: var(--icon-color-disabled);
  }

  .primary-button .button-icon {
    --goto-icon-color: var(--icon-color-inverted);
    fill: var(--icon-color-inverted);
  }

  .secondary-button {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    height: 40px;
    min-width: 80px;
    padding: 10px 16px;
    outline: none;
    cursor: pointer;
    color: var(--type-color-default);
    background-color: transparent;
    border: 1px solid var(--border-color-default);
    border-radius: 4px;
    transition: background-color 150ms ease-out, color 150ms ease-out, fill 150ms ease-out, border-color 150ms ease-out;
    font-size: 16px;
    line-height: 20px;
    font-weight: bold;
    text-decoration: none;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .secondary-button:hover {
    background-color: var(--interactive-color-secondary-hover);
  }

  .secondary-button:active {
    background-color: var(--interactive-color-secondary-pressed);
  }

  .secondary-button:disabled {
    cursor: auto;
    color: var(--type-color-disabled);
    background-color: transparent;
  }

  .secondary-button:disabled .button-icon {
    --goto-icon-color: var(--icon-color-disabled);
    fill: var(--icon-color-disabled);
  }

  .secondary-button .button-icon {
    --goto-icon-color: var(--icon-color-default);
    fill: var(--icon-color-default);
  }

  .tertiary-button {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    height: 40px;
    min-width: 80px;
    padding: 10px 16px;
    outline: none;
    cursor: pointer;
    color: var(--type-color-default);
    background-color: transparent;
    border: 1px solid transparent;
    border-radius: 4px;
    transition: background-color 150ms ease-out, color 150ms ease-out, fill 150ms ease-out, border-color 150ms ease-out;
    font-size: 16px;
    line-height: 20px;
    font-weight: bold;
    text-decoration: none;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .tertiary-button:hover {
    background-color: var(--interactive-color-secondary-hover);
    border: 1px solid var(--interactive-color-secondary-hover);
  }

  .tertiary-button:active {
    background-color: var(--interactive-color-secondary-pressed);
    border: 1px solid var(--interactive-color-secondary-pressed);
  }

  .tertiary-button:disabled {
    cursor: auto;
    color: var(--type-color-disabled);
    background-color: transparent;
    border: 1px solid transparent;
  }

  .tertiary-button:disabled .button-icon {
    --goto-icon-color: var(--icon-color-disabled);
    fill: var(--icon-color-disabled);
  }

  .tertiary-button .button-icon {
    --goto-icon-color: var(--icon-color-default);
    fill: var(--icon-color-default);
  }

  .error-button {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    height: 40px;
    min-width: 80px;
    padding: 10px 16px;
    outline: none;
    cursor: pointer;
    color: var(--type-color-danger);
    background-color: transparent;
    border: 1px solid var(--border-color-danger);
    border-radius: 4px;
    transition: background-color 150ms ease-out, color 150ms ease-out, fill 150ms ease-out, border-color 150ms ease-out;
    font-size: 16px;
    line-height: 20px;
    font-weight: bold;
    text-decoration: none;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .error-button:hover {
    color: var(--type-color-inverted);
    background-color: var(--interactive-color-danger-hover);
    border: 1px solid var(--interactive-color-danger-hover);
  }

  .error-button:hover .button-icon {
    --goto-icon-color: var(--icon-color-inverted);
    fill: var(--icon-color-inverted);
  }

  .error-button:active {
    color: var(--type-color-inverted);
    background-color: var(--interactive-color-danger-pressed);
    border: 1px solid var(--interactive-color-danger-pressed);
  }

  .error-button:active .button-icon {
    --goto-icon-color: var(--icon-color-inverted);
    fill: var(--icon-color-inverted);
  }

  .error-button .button-icon {
    --goto-icon-color: var(--icon-color-danger);
    fill: var(--icon-color-danger);
  }

  .icon-button {
    width: 32px;
    height: 32px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background-color: transparent;
    border: 1px solid transparent;
  }

  .icon-button:hover {
    background-color: var(--interactive-color-secondary-hover);
  }

  .icon-button:active {
    background-color: var(--interactive-color-secondary-pressed);
  }

  .icon-button .button-icon, .icon-button {
    --goto-icon-color: var(--icon-color-default);
    fill: var(--icon-color-default);
    margin: unset;
  }

  .icon-button.disabled, .icon-button:disabled {
    --goto-icon-color: var(--icon-color-disabled);
    background-color: unset;
    cursor: default;
  }

  .icon-button.disabled .button-icon, .icon-button:disabled .button-icon {
    --goto-icon-color: var(--icon-color-disabled);
    fill: var(--icon-color-disabled);
  }

  .button-icon {
    --goto-icon-size: 20px;
    margin-right: 10px;
    margin-left: -4px;
    width: 20px;
    height: 20px;
  }
`;
export default buttons;
